var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyChooseIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Group_140506",
    "data-name": "Group 140506",
    width: 23.29,
    height: 23.263,
    viewBox: "0 0 23.29 23.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64086",
    "data-name": "Rectangle 64086",
    width: 23.29,
    height: 23.263,
    fill: "#073c00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_140387",
    "data-name": "Group 140387",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119175",
    "data-name": "Path 119175",
    d: "M8.159,2.327H7V0h9.3V2.32H15.136v.143q0,3.7,0,7.4a.273.273,0,0,0,.092.212q3.473,3.465,6.945,6.932a3.684,3.684,0,0,1,1.066,2.024,3.621,3.621,0,0,1-2.727,4.122,4.091,4.091,0,0,1-.9.106q-7.966.01-15.932,0A3.6,3.6,0,0,1,.082,20.344a3.428,3.428,0,0,1,.94-3.223C2.564,15.548,4.135,14,5.694,12.445q1.191-1.19,2.379-2.381a.311.311,0,0,0,.082-.2q.006-3.7,0-7.4V2.327",
    transform: "translate(0 -0.001)",
    fill: "#073c00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyChooseIcon1);
export default __webpack_public_path__ + "static/media/whyChoose-icon1.5e23c51337d0530e08b00b2308308705.svg";
export { ForwardRef as ReactComponent };